import "../w3.css"

const Page404 = () => {
    return (
        <h1>404 - Page does not exist</h1>
    )
}

export default Page404